import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Settings } from 'lucide-react';

export const PortalManagementPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Portal Management</h1>
          <p className="text-muted-foreground">
            Manage portal configurations across all customers
          </p>
        </div>
        <Button 
          onClick={() => navigate('/dashboard/portals')}
          className="flex items-center gap-2"
        >
          <Settings className="w-4 h-4" />
          Open Portal Dashboard
        </Button>
      </div>
      
      <div className="text-center py-12">
        <p className="text-muted-foreground">
          Portal management features are being loaded...
        </p>
      </div>
    </div>
  );
};